import template from './network_modal.html';

angular.module('bb.util').component('networkModal', {
  transclude: true,
  bindings: {},
  controller: networkModalController,
  controllerAs: 'vm',
  template,
});

networkModalController.$inject = ['$rootScope', 'ModalService'];
function networkModalController($rootScope, ModalService) {
  const vm = this;

  vm.networkModal = ModalService.networkModal;

  vm.auth = $rootScope.auth;

  vm.closeModal = function () {
    ModalService.closeNetworkModal();
  };
}
